import constant from '../constants/freeSpaceAreaConstant';

export const freeSpaceAreaInitialState = {

    layerTypes: [],
    selectedLayerTypes: [],
    isShowDialog:false,

}

export function freeSpaceAreaReducer(state, action) {

    switch (action.type) {

        case constant.GET_LAYER_STRUCTURES:
            return {
                ...state,
                layerTypes: action.payload
            };
        case constant.SET_SELECTED_LAYER_TYPES:
            return {
                ...state,
                selectedLayerTypes: action.payload
            };
        case constant.SET_FREE_SPACE_SHOW_DIALOG:
            return {
                ...state,
                isShowDialog: action.payload
            };
 

        default:
            return state;
    }
}

export default freeSpaceAreaReducer;
